import { defineMessages } from 'react-intl';

export default defineMessages({
    stepCoverables: {
        id: 'gateway.PremierEL.wizard.step.Coverables',
        defaultMessage: 'Coverables',
    },
    questions: {
        id: 'gateway.PremierEL.wizard.step.Questions',
        defaultMessage: 'Questions',
    },
    stepCoverages: {
        id: 'gateway.PremierEL.wizard.step.Coverages',
        defaultMessage: 'Coverages',
    },
    exposures: {
        id: 'gateway.PremierEL.wizard.step.Exposures',
        defaultMessage: 'Exposures',
    },
    anErrorOccurred: {
        id: 'quoteandbind.PremierEL.wizard.error',
        defaultMessage: 'Something went wrong during this process.',
    },
    anErrorOccurredTitle: {
        id: 'quoteandbind.PremierEL.wizard.error.title',
        defaultMessage: 'Error',
    },
    saveQuoteError: {
        id: 'quoteandbind.PremierEL.wizard.Unable to quote',
        defaultMessage: 'Unable to quote',
    },
    saveQuoteErrorMessage: {
        id: 'quoteandbind.PremierEL.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.',
    },
});
